import { Settings20Regular, SignOut20Regular, WeatherMoon20Regular, WeatherSunny20Regular } from '@/components/Icon'

export const PRIMARY_ACCOUNT_MENU_ACTION = {
  THEME: 'theme',
  SETTINGS: 'settings',
  SIGN_OUT: 'signOut',
}

export function getPrimaryNavAccountMenuItems(resolvedMode = 'light') {
  const toDark = resolvedMode !== 'dark'
  return [
    {
      id: PRIMARY_ACCOUNT_MENU_ACTION.THEME,
      label: toDark ? 'Switch to : Dark theme' : 'Switch to : Light theme',
      Icon: toDark ? WeatherMoon20Regular : WeatherSunny20Regular,
    },
    {
      id: PRIMARY_ACCOUNT_MENU_ACTION.SETTINGS,
      label: 'Settings',
      Icon: Settings20Regular,
    },
    {
      id: PRIMARY_ACCOUNT_MENU_ACTION.SIGN_OUT,
      label: 'Sign out',
      Icon: SignOut20Regular,
      variant: 'danger',
    },
  ]
}
